<template>
  <div>
    <v-app-bar
    color="grey darken-4"
      gradient
      app
      dark
    >
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <span class="h3 grey--text" v-if="$vuetify.breakpoint.mdAndUp" style="font-family: esquare;font-size: 2em; font-weight: bold;">
        JESSE STEWART
      </span>
      <v-spacer></v-spacer>
      <template v-if="$vuetify.breakpoint.smAndUp" v-slot:extension>
        <v-tabs centered>
          <v-tab title="Home" router to="/">
            <v-icon>mdi-home</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs centered>
          <v-tab title="Philosophy" router to="/philosophy">
            <v-icon>mdi-book</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs centered>
          <v-tab title="About" router to="/about">
            <v-icon>mdi-account</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs centered>
          <v-tab title="Skills" router to="/skills">
            <v-icon>mdi-cog</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs centered>
          <v-tab title="Contact" router to="/contact">
            <v-icon>mdi-email</v-icon>
          </v-tab>
        </v-tabs>
      </template>
      <v-btn @click="$router.push({path: '/'})" icon>
        <svg width="18" height="40" viewBox="0 0 18 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.70009 27.3664V33.5674C6.70009 33.7529 6.89282 33.9016 7.04662 33.9016H10.4733C10.7042 33.9016 10.8969 33.7529 10.8969 33.5674V16.0416H17.5959V36.4636C17.5959 38.0974 16.2868 39.3226 14.6697 39.3226H2.96556C1.38716 39.3226 0.00106812 38.0974 0.00106812 36.4636V27.3664H6.70009Z" fill="white"/>
          <path d="M10.8958 11.9563V5.75537C10.8958 5.56991 10.7035 5.42117 10.5493 5.42117H7.12255C6.89175 5.42117 6.69924 5.56991 6.69924 5.75537V23.2812H0L0.000213786 2.85922C0.000213786 1.22538 1.30909 3.9308e-06 2.9262 3.9308e-06H14.6303C16.209 3.9308e-06 17.5948 1.22538 17.5948 2.85922V11.9563H10.8958Z" fill="white"/>
        </svg>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      fixed
      app
      temporary
      v-model="drawer"
      dark
    >
      <v-list dense nav class="py-0 overline grey--text">
        <v-list-item class="my-2" to="/" link>
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="my-2" to="/philosophy" link>
          <v-list-item-icon>
            <v-icon>mdi-book</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>philosophy</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

				<v-list-item class="my-2" to="/about" link>
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
							about
						</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

				<v-list-item class="my-2" to="/skills" link>
          <v-list-item-icon>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
							skills
						</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

				<!-- <v-list-item class="my-2" to="/work" link>
          <v-list-item-icon>
            <v-icon>mdi-eye</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
							My Work
						</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

				<v-list-item class="my-2" to="/contact" link>
          <v-list-item-icon>
            <v-icon>mdi-email</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
							Contact
						</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      right: false,
      permanent: true,
      miniVariant: false,
      expandOnHover: false,
      background: false,
    }
  },
  computed: {
    bg() {
      return this.background
        ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg'
        : undefined
    },
  },
  methods: {
  },
  mounted() {
  },
}
</script>

<style scoped>
.font {
  font-family: esquare;
  color: white;
  font-variant: small-caps;
}
</style>
